import { GameStatus } from '@betterpool/api-types/games-service';

import type { PlayerPoolMember } from '~/domains/contest/domains/services/interfaces/player-pool-member.interface';
import type { PickForEntry } from '~/domains/contest/domains/services/interfaces/picks-for-entry.interface';
import type { PlayerDetail } from '~/domains/games/interfaces/player-detail.interface';

import type { PlayerInfo } from '../../types/player';

import parseNonScheduledTeamSport from './parseNonScheduledTeamSport';
import parseBasePlayerInfoTeamSport from './parseBasePlayerInfoTeamSport';
import parseScheduledPlayerSport from './parseSchedulePlayerSport';

const parseNonScheduledBaseball = (
  pickWithLiveData: PickForEntry | PlayerDetail
): Partial<PlayerInfo> => {
  const isLive = pickWithLiveData.attributes.gameStatus === GameStatus.IN_PROGRESS;

  return {
    // playerActivities has stats for the current slate
    ...(pickWithLiveData.playerActivities && {
      meta: [
        {
          label: 'SCORE',
          value: pickWithLiveData.playerActivities?.score ?? '-',
        },
        {
          label: 'POS',
          value: pickWithLiveData.playerActivities?.position ?? '-',
        },
        {
          label: 'TIED',
          value: pickWithLiveData.playerActivities?.tied ? 'Yes' : 'No',
        },
      ],
    }),
    gameTime: (() => {
      if (!isLive) {
        return 'FINAL';
      }

      if (!pickWithLiveData.attributes.summary) return '-';
      const inningPhase = pickWithLiveData.attributes.summary.inningPhase || '';
      const inning = pickWithLiveData.attributes.summary.inning || '';
      return inning ? `${inningPhase} ${inning}` : '-';
    })(),
  };
};

const parseNonScheduled = (pickWithLiveData: PickForEntry | PlayerDetail) => ({
  ...parseNonScheduledBaseball(pickWithLiveData),
  ...parseNonScheduledTeamSport(pickWithLiveData),
});

const parseBaseballPlayerInfo = (pick: PlayerPoolMember): Partial<PlayerInfo> => ({
  ...parseScheduledPlayerSport(pick),
  ...parseBasePlayerInfoTeamSport(pick),
});

export default parseBaseballPlayerInfo;

export { parseNonScheduled as parseBaseballPlayerInfoAfterGameStart };
